import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-2"
}
const _hoisted_2 = { class: "fw-700" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "mas align-middle" }, "add", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDeleteButton = _resolveComponent("BaseDeleteButton")!
  const _component_BoxShadowLayerDetail = _resolveComponent("BoxShadowLayerDetail")!
  const _component_MetadataGroupCard = _resolveComponent("MetadataGroupCard")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createVNode(_component_MetadataGroupCard, {
        title: _ctx.$t('cms.shadow'),
        enabled: _ctx.enabled,
        name: _ctx.$t('cms.shadow'),
        errors: _ctx.errors,
        "onUpdate:enabled": _ctx.onEnabledChanged,
        onReset: _ctx.resetToPersisted
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localDto.layers, (_layer, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass({'border rounded p-2 mb-2': _ctx.hasMultipleLayers})
              }, [
                (_ctx.hasMultipleLayers)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('cms.boxShadowLayer')) + " " + _toDisplayString(index + 1), 1),
                      _createVNode(_component_BaseDeleteButton, {
                        deleteData: () => _ctx.removeLayer(index),
                        pageUI: _ctx.componentUI,
                        class: "btn-sm"
                      }, null, 8, ["deleteData", "pageUI"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_BoxShadowLayerDetail, {
                  modelValue: _ctx.localDto.layers[index],
                  "onUpdate:modelValue": [($event: any) => ((_ctx.localDto.layers[index]) = $event), _ctx.emitModelChanged],
                  name: `${_ctx.$t('cms.boxShadowLayer')} ${index + 1}`,
                  errors: _ctx.errors
                }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "errors"])
              ], 2))
            }), 128)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-link btn-sm p-0 mb-2",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addLayer && _ctx.addLayer(...args)), ["prevent"]))
            }, [
              _hoisted_3,
              _createTextVNode(_toDisplayString(_ctx.$t('cms.boxShadowAddLayer')), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["title", "enabled", "name", "errors", "onUpdate:enabled", "onReset"])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}